var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"customCheckbox"},[_c('div',{staticClass:"customCheckbox__wrapper"},[_c('input',{staticClass:"customCheckbox__input",attrs:{"type":"checkbox"},domProps:{"checked":_vm.isChecked},on:{"change":_vm.handleCheckedChange}}),_c('span',{staticClass:"customCheckbox__checkmark",style:({
        backgroundColor: _vm.isChecked && _vm.color ? _vm.color : '',
        border: _vm.isChecked ? 'none' : '',
      })})]),_c('span',{staticClass:"customCheckbox__label"},[_vm._v(_vm._s(_vm.label))])])
}
var staticRenderFns = []

export { render, staticRenderFns }